var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToneInform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-161 -652)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3,
    transform: "translate(161 652)",
    fill: "#1074ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.484,8.949l-1.223-4.9a2.372,2.372,0,0,0-3.053-1.676l-.411.137a.431.431,0,0,0-.273.546l.136.409a.431.431,0,0,0,.546.273l.355-.118a1.153,1.153,0,0,1,.894.047,1.069,1.069,0,0,1,.549.7L14.043,8.51a7.464,7.464,0,0,0-2.19-.336,7.075,7.075,0,0,0-3.1.721H6.781a7.068,7.068,0,0,0-3.1-.721,7.465,7.465,0,0,0-2.19.336L2.53,4.361a1.068,1.068,0,0,1,.55-.7,1.153,1.153,0,0,1,.894-.047l.355.118a.431.431,0,0,0,.546-.273l.136-.409a.431.431,0,0,0-.273-.546l-.411-.137A2.372,2.372,0,0,0,1.274,4.047L.051,8.949A1.732,1.732,0,0,0,0,9.366v1.895a3.09,3.09,0,0,0,3.107,3.072h1a3.093,3.093,0,0,0,3.1-2.842l.079-1.042H8.25l.079,1.042a3.092,3.092,0,0,0,3.1,2.842h1a3.09,3.09,0,0,0,3.107-3.072V9.367A1.733,1.733,0,0,0,15.484,8.949Zm-10,2.412a1.373,1.373,0,0,1-1.377,1.246h-1a1.365,1.365,0,0,1-1.381-1.346V10.249A5.855,5.855,0,0,1,3.684,9.9a5.292,5.292,0,0,1,1.886.348Zm8.324-.1a1.365,1.365,0,0,1-1.381,1.345h-1A1.372,1.372,0,0,1,10.05,11.36l-.084-1.112A5.294,5.294,0,0,1,11.852,9.9a5.855,5.855,0,0,1,1.957.349v1.013Z",
    transform: "translate(167.96 658.251)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToneInform);
export default __webpack_public_path__ + "static/media/tone_inform.dc545ee3e1bec6d2903cfb50e704f7a2.svg";
export { ForwardRef as ReactComponent };